<template>
    <div class="registro">
        <div class="container">
            <div class="row">
                <div class="col-md-6" style="text-align: center;">
                    <img src="/static/registro/ImgRegistro.jpg" alt="">
                </div>
                <div class="col-md-6">
                    <div class="texto">
                        <p>
                            Bienvenidos a <b>World Part Online</b>, la plataforma digital exclusiva para la comercialización de
                            repuestos y accesorios de todos las marcas, de todas las industrias.
                        </p>
                        <p>
                            Esta herramienta digital te permitirá estar conectado con todos los profesionales, compradores y
                            vendedores del rubro de una forma fácil, dinámica y efectiva.
                        </p>
                        <p>
                            Podrás comprar y vender recibiendo las mejores propuestas en tiempo y precio, además tendrás la
                            posibilidad de ser valorado por tu servicio y recibir importantes incentivos.
                        </p>
                        <p>
                            <b>World Part Online</b> es la herramienta que faltaba, publicidad, negocio, estadísticas,
                            asesoramiento, distribución, sistemas. Todo y de una forma muy fácil y pro activa.
                        </p>
                        <p><b>World Part Online</b>, liderá tu mundo.</p>
                    </div>
                </div>
            </div>
            <!--FORM-->
            <form>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Nombre:*</label>
                            <div class="col-sm-10">
                                <input v-model="registro.nombre" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Telefono:</label>
                            <div class="col-sm-10">
                                <input v-model="registro.telefono" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Perfil:</label>
                            <div class="col-sm-10">
                                <select class="form-control" v-model="registro.perfil">
                                    <option>Motos</option>
                                    <option>Autos</option>
                                    <option>Camionetas</option>
                                    <option>Camiones</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Apellido:*</label>
                            <div class="col-sm-10">
                                <input v-model="registro.apellido" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label">Empresa:</label>
                            <div class="col-sm-10">
                                <input v-model="registro.empresa" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2 col-form-label">E-mail:*</label>
                            <div class="col-sm-10">
                                <input v-model="registro.mail" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-2">Ocupación:</label>
                            <div class="col-sm-10">
                                <div class="form-check">
                                    <label class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" v-model="registro.comprador">  
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">Comprador</span>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <label class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input" v-model="registro.vendedor">
                                        <span class="custom-control-indicator"></span>
                                        <span class="custom-control-description">Vendedor</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 offset-md-3">
                        <h6>¿CÓMO CONOCISTE WPO?</h6>
                        <select v-model="registro.origen" class="form-control">
                            <option>RECIBI UN MAIL</option>
                            <option>POR AMIGOS</option>
                            <option>OTROS</option>
                        </select>
                    </div>

                    <div class="col-md-6 offset-md-3" style="margin-top: 20px;">
                        <button @click="enviarRegistro" type="button" class="btn btn-primary btn-block">ENVIAR</button>
                    </div>

                    <div class="col-md-12" style="margin-top: 20px; text-align:center;">
                        <p class="terminos">Al registrarme declaro que soy mayor de edad y acepto<br>
                            <a href="#">Los Terminos y condiciones</a>  y las <a href="#">Politicas de privacidad</a> 
                        </p>
                    </div>
                </div>
            </form>
            <!--FORM-->
          </div>
        </div>
    </div>  
</template>

<script>

import firebase from 'firebase'
import { Registrar } from '../services/website/website.service.js'

export default {
    name: 'registro',

    data () {
        return {
            registro: {
                nombre: null,
                apellido: null,
                telefono: null,
                mail: null,
                empresa: null,
                perfil: null,
                comprador: false,
                vendedor: false,
                origen: null,
            }
        }
    },

    methods: {
        enviarRegistro() {
            var result = Registrar(this.registro)
            if (result.estado == false) {
                this.$notie.alert(3, result.mensajes.join('<br />') , 2)
            }
            else {
                this.$notie.alert(1, 'Registro exitoso.' , 2);
                this.$router.push({ path: '/'});
            }
        }
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.registro {
    background-color: #2AABE4;
    padding: 5%;
}
.registro .container {
    background-color: #fff;
    padding-bottom: 20px;
    margin-bottom: 50px;
    border-radius: 10px;
}
.row img {
    opacity: 0.5;
    width: 100%;
}
.texto {
    padding: 10%;
}
.header {
    padding: 5%;
}
.btn-primary {
    background-color: #196C7E;
    border-color: #196C7E;
}
.terminos {
    font-size: 14px;
}

.custom-control {
    padding-top:5px;
    padding-left:2.5em;
}

.bootstrap-select.btn-group .dropdown-menu option:hover{
      background-color: rgb(191, 82, 121);
      color: white;
}

.custom-control-indicator {
    background-color: #2AABE4;
    width: 30px;
    height: 30px;
}

.custom-control-input:checked~.custom-control-indicator {
    color: #fff;
    background-color: #2AABE4;
}
h6 {
    text-align:center;
}
</style>



// WEBPACK FOOTER //
// Registro.vue?40d06cdb